/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chars_UnitInputs */

const en_chars_unit = /** @type {(inputs: Chars_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`char(s)`)
};

const fr_chars_unit = /** @type {(inputs: Chars_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caract.`)
};

const de_chars_unit = /** @type {(inputs: Chars_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen`)
};

const it_chars_unit = /** @type {(inputs: Chars_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`carattere/i`)
};

const ru_chars_unit = /** @type {(inputs: Chars_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`символ(ы)`)
};

const es_chars_unit = /** @type {(inputs: Chars_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`carácter(es)`)
};

const zh_cn2_chars_unit = /** @type {(inputs: Chars_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字符`)
};

const ja_chars_unit = /** @type {(inputs: Chars_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字`)
};

const hi_chars_unit = /** @type {(inputs: Chars_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अक्षर(ओं)`)
};

const pt_pt2_chars_unit = /** @type {(inputs: Chars_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caractere(s)`)
};

/**
* | output |
* | --- |
* | "char(s)" |
*
* @param {Chars_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const chars_unit = /** @type {((inputs?: Chars_UnitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chars_UnitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_chars_unit(inputs)
	if (locale === "de") return de_chars_unit(inputs)
	if (locale === "it") return it_chars_unit(inputs)
	if (locale === "ru") return ru_chars_unit(inputs)
	if (locale === "es") return es_chars_unit(inputs)
	if (locale === "zh-CN") return zh_cn2_chars_unit(inputs)
	if (locale === "ja") return ja_chars_unit(inputs)
	if (locale === "hi") return hi_chars_unit(inputs)
	if (locale === "pt-PT") return pt_pt2_chars_unit(inputs)
	return en_chars_unit(inputs)
});